import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

interface OfferSummaryContainerProps {
    positiveHover?: boolean;
    specialHover?: boolean;
}

export const OfferSummaryContainer = styled.div<OfferSummaryContainerProps>`
    position: relative;
    cursor: pointer;
    padding: ${theme.space[16]};

    &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: ${(props) =>
            props.specialHover && !props.positiveHover
                ? 'linear-gradient(212.33deg, rgba(103, 0, 254, 0.2) 0%, rgba(255, 255, 255, 0) 40%)'
                : 'linear-gradient(212.33deg, rgba(0, 204, 105, 0.2) 0%, rgba(255, 255, 255, 0) 40%)'};
        opacity: 0;
        transition: opacity 150ms ease-in;
        pointer-events: none;
    }

    &:hover::after {
        opacity: ${(props) => (props.positiveHover || props.specialHover ? 1 : 0)};
    }
`;
